import styled from 'styled-components';

const FadedText = styled.span`
  color: ${({ theme }) => theme.colorsNewDesign.gray500};
  line-height: 1.7;
  font-size: ${({ theme }) => theme.fontSizesNewDesign.xs};
`;

export default FadedText;
